import { Form } from 'antd';

import { OptionWrapper, MobileWrapper, Wrapper } from './VoteSelector.styles';

import { useIsMobile } from '@/hooks';
type Props = {
  value?: number;
  onChange?: (value: number) => void;
};

const OPTIONS = Array.from({ length: 11 }, (_, i) => i);

const MOBILE_OPTIONS_TOP = OPTIONS.slice(0, 4);
const MOBILE_OPTIONS_MIDDLE = OPTIONS.slice(4, 7);
const MOBILE_OPTIONS_BOTTOM = OPTIONS.slice(7, 11);

export const VoteSelector: React.FC<Props> = ({ value, onChange }) => {
  const isMobile = useIsMobile('sm');
  const form = Form.useFormInstance();
  const handleChange = (option: number) => {
    onChange?.(option);
    form.setFieldsValue({ reasons: undefined, comment: undefined });
  };
  if (isMobile) {
    return (
      <MobileWrapper>
        <Wrapper>
          {MOBILE_OPTIONS_TOP.map(option => (
            <OptionWrapper
              number={option}
              key={option}
              isSelected={option === value}
              onClick={() => handleChange?.(option)}>
              {option}
            </OptionWrapper>
          ))}
        </Wrapper>
        <Wrapper>
          {MOBILE_OPTIONS_MIDDLE.map(option => (
            <OptionWrapper
              number={option}
              key={option}
              isSelected={option === value}
              onClick={() => handleChange?.(option)}>
              {option}
            </OptionWrapper>
          ))}
        </Wrapper>
        <Wrapper>
          {MOBILE_OPTIONS_BOTTOM.map(option => (
            <OptionWrapper
              number={option}
              key={option}
              isSelected={option === value}
              onClick={() => handleChange?.(option)}>
              {option}
            </OptionWrapper>
          ))}
        </Wrapper>
      </MobileWrapper>
    );
  }

  return (
    <Wrapper>
      {OPTIONS.map(option => (
        <OptionWrapper
          number={option}
          key={option}
          isSelected={option === value}
          onClick={() => handleChange?.(option)}>
          {option}
        </OptionWrapper>
      ))}
    </Wrapper>
  );
};
